<div>
  <!-- Excluding 'accuracy', 'contractid', 'contractname'-->
  <div>{{'Car id' | translate }}: {{ selectedFeature.properties.carid }}</div>
  <div>{{'Car type' | translate }}: {{ selectedFeature.properties.cartype }}</div>
  <div>{{'Operation name' | translate }}: {{ selectedFeature.properties.operationname }}</div>
  <div>{{'Speed' | translate }}: {{ selectedFeature.properties.speed | qmRound : 2 }} km/h</div>
  <div>{{'Street address' | translate }}: {{ selectedFeature.properties.streetaddress }}</div>
  <div>{{'Latitude' | translate}}: {{selectedFeature.geometry.coordinates[1] | qmRound : 5 }}</div>
  <div>{{'Longitude' | translate}}: {{selectedFeature.geometry.coordinates[0] | qmRound : 5 }}</div>
  <div>{{'Location updated' | translate}}: {{selectedFeature.properties.createdon | qmDateDistance}}</div>

  <button
    id="fluent-fetch"
    class="btn btn-primary custom-button"
    *ngIf="showAdditionalInfoButton && selectedFeature.properties.carid && !(additionalInfo.result?.status === 'OK')"
    [disabled]="additionalInfo.request && additionalInfo.result?.status !== 'ERROR'"
    (click)="requestAdditionalInfo(selectedFeature.properties.carid)">
    {{ 'Additional info' | translate }}
  </button>

  <div *ngIf="additionalInfo.result?.status === 'ERROR'" class="error">
    {{ 'Fetching additional info from Fluent API failed' | translate }}
  </div>

  <span *ngIf="additionalInfo?.result?.status === 'OK'">
    <div>{{ 'Car name' | translate }}: {{ additionalInfo.result.carname }}</div>
    <div>{{ 'Driver name' | translate }}: {{ additionalInfo.result.drivername }}</div>
  </span>
</div>
